<template>
  <div>
    <figure class="default-avatar">
      <img
        class="rounded-circle"
        :src="currentAvatar"
        style="object-fit: contain"
        alt="custom avatar"
      />
    </figure>
  </div>
</template>

<script>
export default {
  props: { photo: String, employer: String },
  data: () => ({
    cssRule: 'cover',
    title: '',
    currentAvatar: '',
    temporaryAvatar: null,
    file: null,
    isChanged: false,
    getUrl: null,
    resetUrl: null,
    uploadUrl: null,
    employerID: '',
  }),
  watch: {
    photo: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === 'default.png' || newVal === null) {
          this.currentAvatar = 'https://jobshark.eu/img/comstream.svg';
        } else {
          this.currentAvatar = `https://jobshark.eu/storage/employers/logos/${newVal}`;
        }
      }
    },

    employer: function (newVal) {
      this.resetUrl = `/admin/employer/deleteavatar/${newVal}`;
    },
  },
  mounted() {
    this.title = 'Change your logo type';
    this.uploadUrl = '/admin/employer/uploadavatar';
  },
};
</script>
<style lang="scss" scoped>
.default-avatar {
  position: relative;
  width: 74px;
  height: 74px;
  margin: 0 12px 0 15px;
  flex-shrink: 0;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none !important;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
.temporary-avatar {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: contain;
}
</style>
